// extracted by mini-css-extract-plugin
module.exports = {"editModal":"editModal__hC8jt","label":"label__8D+04","input":"input__eXLSQ","buttons":"buttons__yjaiV"};